import { useEffect, useState } from "react";
import { Modal, Select, Button, Typography, Alert } from "antd";
import toast from "react-hot-toast";
import { getTeachers } from "../../../services/auth";
import api from "../../../services/api";
const { Option } = Select;

const AddFeaturedTeachersModal = ({ show, onCancel, refreshData }) => {
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchTeachers = async () => {
    try {
      const allTeacher = await getTeachers();
      // filter out approved and unFeatured teachers
      const approvedTeachers = allTeacher?.data?.data?.filter(
        (t) => t.approved && !t?.isFeatured
      );
      setTeachers(approvedTeachers || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  const handleSend = async () => {
    if (!selectedTeacher) {
      toast.error("Please select teacher");
      return;
    }
    setLoading(true);

    try {
      const req = await api.put(
        "/admin/teachers/featured",
        { teacherId: selectedTeacher }
      );
      if (req.status === 200) {
        // eslint-disable-next-line
        toast.success("Featured added successfully!");
        setSelectedTeacher("");
        const filtered = teachers?.filter((x) => x?.id !== selectedTeacher);
        setSelectedTeacher(filtered);
        onCancel();
        refreshData();
      }
    } catch (error) {
      toast.error("Error" + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={show}
      onCancel={onCancel}
      footer={null}
      title={`Add Featured Teacher`}
    >
      <Alert
        message="Only approved teachers can be marked as featured teachers."
        type="info"
        showIcon
        // style={{ marginBottom: 10 }}
      />

      <div className="space-y-5">
        {/* Teachers */}
        <div className="my-4">
          <Typography.Text strong>Select a Teacher</Typography.Text>
          <div style={{ marginTop: 8 }}>
            <Select
              value={selectedTeacher}
              onChange={setSelectedTeacher}
              placeholder={`Select a Teacher`}
              style={{ width: "100%" }}
            >
              {teachers?.map((item) => (
                <Option key={item?.id} value={item?.id}>
                  {item?.fullName}
                </Option>
              ))}
            </Select>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-2 mt-2">
          <Button
            onClick={onCancel}
            className="btn btn_outlined fs_12 btn-sm text-black px-3"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSend}
            loading={loading}
            className="btn btn_contained fs_12 btn-sm text-white px-3"
          >
            Add
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddFeaturedTeachersModal;
